export function isProvenanceKey(key: string): boolean {
  return key.startsWith('_');
}

export type ValueKind = 'scalar' | 'object' | 'object-array' | 'scalar-array' | 'scalar-map' | 'empty';

export function classifyValue(v: unknown): ValueKind {
  if (Array.isArray(v)) {
    if (v.length === 0) return 'empty';
    return v.every((x) => x !== null && typeof x === 'object' && !Array.isArray(x))
      ? 'object-array' : 'scalar-array';
  }
  if (v !== null && typeof v === 'object') {
    const entries = Object.entries(v as Record<string, unknown>);
    if (entries.length === 0) return 'empty';
    // A flat map whose every value is a scalar (and no provenance keys) reads as
    // a 2-column lookup table (e.g. a by_hrt_status admissibility matrix), not a
    // stack of one-value sections.
    const flatScalar = entries.every(([k, val]) => !isProvenanceKey(k) && (val === null || typeof val !== 'object'));
    return flatScalar ? 'scalar-map' : 'object';
  }
  return 'scalar';
}

export function tableColumns(rows: Array<Record<string, unknown>>): string[] {
  const cols = new Set<string>();
  for (const r of rows) for (const k of Object.keys(r)) cols.add(k);
  return Array.from(cols).sort();
}

export function scalarText(v: unknown): string {
  if (v === null || v === undefined) return '—';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
}

/** For status-ish scalars (admissibility, active flags), a pill tone — else null. */
export function statusTone(v: unknown): 'good' | 'bad' | null {
  if (typeof v === 'boolean') return v ? 'good' : 'bad';
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    if (s === 'valid' || s === 'yes' || s === 'true') return 'good';
    if (s === 'invalid' || s === 'no' || s === 'false') return 'bad';
  }
  return null;
}
